module.exports = __webpack_public_path__ + "static/media/full_star.c6796b75.svg";